import React from "react";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import backend from "../../../../api";
import { Link, useHistory, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import SubmitButton from "../../../common/buttons/SubmitButton";

const EmoneyOnboard = ({ type, accountId }) => {
  const { user } = useSelector((state) => state.auth);
  const {
    handleSubmit,
    register,
    errors,
    formState: { isSubmitting },
  } = useForm();

  const history = useHistory();

  const FRONTEND_EMONEY =
    process.env.NODE_ENV === "production"
      ? process.env.REACT_APP_FRONTEND_EMONEY
      : process.env.REACT_APP_FRONTEND_EMONEY_DEV;

  const onSubmit = async (data) => {
    try {
      const payload = {
        userId: user?.user?._id,
        type,
        accountId: data.accountId,
        isDefault: data.isDefault || false,
        redirectUrl: `/view-account/e-money/${data.accountId}`,
      };

      const response = await backend.post("/accounts/add", payload);
      const { message, account } = response?.data;
      toast.success(message);
      history.push(`/view-account/e-money/${data.accountId}/${account?._id}`);
    } catch (error) {
      console.error("Error:", error);
      toast.error(
        error?.response
          ? error?.response?.data?.message
          : "Action Add Failed, Try again later!"
      );
    }
  };

  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="row">
          <div className="col-6">
            <div className="form-group">
              <label htmlFor="accountId">E-money Account No.</label>
              <input
                type="text"
                id="accountId"
                name="accountId"
                placeholder="E-money Account Id"
                className="form-control"
                ref={register({
                  required: {
                    value: true,
                    message: "This field is required",
                  },
                })}
              />
              {errors.accountId && (
                <div className="error mt-1">{errors.accountId.message}</div>
              )}
              <small>
                If dont have E-money account{" "}
                <a href={FRONTEND_EMONEY} target="_blank">click here</a> to create one
              </small>
            </div>
          </div>
        </div>
        <SubmitButton type="submit" isSubmitting={isSubmitting}>
          {"Get Started"}
        </SubmitButton>
      </form>
    </div>
  );
};

export default EmoneyOnboard;
